import React from "react";
import { ArrowCounterClockwise as PhArrowCounterClockwise } from "@phosphor-icons/react/dist/csr/ArrowCounterClockwise";
import { ArrowLeft as PhArrowLeft } from "@phosphor-icons/react/dist/csr/ArrowLeft";
import { ArrowRight as PhArrowRight } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { ArrowsClockwise as PhArrowsClockwise } from "@phosphor-icons/react/dist/csr/ArrowsClockwise";
import { ArrowsDownUp as PhArrowsDownUp } from "@phosphor-icons/react/dist/csr/ArrowsDownUp";
import { Barricade as PhBarricade } from "@phosphor-icons/react/dist/csr/Barricade";
import { Bell as PhBell } from "@phosphor-icons/react/dist/csr/Bell";
import { BookOpen as PhBookOpen } from "@phosphor-icons/react/dist/csr/BookOpen";
import { CalendarBlank as PhCalendarBlank } from "@phosphor-icons/react/dist/csr/CalendarBlank";
import { CalendarDots as PhCalendarDots } from "@phosphor-icons/react/dist/csr/CalendarDots";
import { CalendarPlus as PhCalendarPlus } from "@phosphor-icons/react/dist/csr/CalendarPlus";
import { CaretDown as PhCaretDown } from "@phosphor-icons/react/dist/csr/CaretDown";
import { CaretLeft as PhCaretLeft } from "@phosphor-icons/react/dist/csr/CaretLeft";
import { CaretRight as PhCaretRight } from "@phosphor-icons/react/dist/csr/CaretRight";
import { CaretUp as PhCaretUp } from "@phosphor-icons/react/dist/csr/CaretUp";
import { Check as PhCheck } from "@phosphor-icons/react/dist/csr/Check";
import { CheckCircle as PhCheckCircle } from "@phosphor-icons/react/dist/csr/CheckCircle";
import { Circle as PhCircle } from "@phosphor-icons/react/dist/csr/Circle";
import { ClipboardText as PhClipboardText } from "@phosphor-icons/react/dist/csr/ClipboardText";
import { Clock as PhClock } from "@phosphor-icons/react/dist/csr/Clock";
import { ClockCounterClockwise as PhClockCounterClockwise } from "@phosphor-icons/react/dist/csr/ClockCounterClockwise";
import { Copy as PhCopy } from "@phosphor-icons/react/dist/csr/Copy";
import { Cube as PhCube } from "@phosphor-icons/react/dist/csr/Cube";
import { DotsSixVertical as PhDotsSixVertical } from "@phosphor-icons/react/dist/csr/DotsSixVertical";
import { DotsThree as PhDotsThree } from "@phosphor-icons/react/dist/csr/DotsThree";
import { DownloadSimple as PhDownloadSimple } from "@phosphor-icons/react/dist/csr/DownloadSimple";
import { Drop as PhDrop } from "@phosphor-icons/react/dist/csr/Drop";
import { Envelope as PhEnvelope } from "@phosphor-icons/react/dist/csr/Envelope";
import { EnvelopeOpen as PhEnvelopeOpen } from "@phosphor-icons/react/dist/csr/EnvelopeOpen";
import { Eye as PhEye } from "@phosphor-icons/react/dist/csr/Eye";
import { FileText as PhFileText } from "@phosphor-icons/react/dist/csr/FileText";
import { Receipt as PhReceipt } from "@phosphor-icons/react/dist/csr/Receipt";
import { FileXls as PhFileXls } from "@phosphor-icons/react/dist/csr/FileXls";
import { Funnel as PhFunnel } from "@phosphor-icons/react/dist/csr/Funnel";
import { GearSix as PhGearSix } from "@phosphor-icons/react/dist/csr/GearSix";
import { HandCoins as PhHandCoins } from "@phosphor-icons/react/dist/csr/HandCoins";
import { Image as PhImage } from "@phosphor-icons/react/dist/csr/Image";
import { Info as PhInfo } from "@phosphor-icons/react/dist/csr/Info";
import { Key as PhKey } from "@phosphor-icons/react/dist/csr/Key";
import { List as PhList } from "@phosphor-icons/react/dist/csr/List";
import { ListChecks as PhListChecks } from "@phosphor-icons/react/dist/csr/ListChecks";
import { ListPlus as PhListPlus } from "@phosphor-icons/react/dist/csr/ListPlus";
import { MagnifyingGlass as PhMagnifyingGlass } from "@phosphor-icons/react/dist/csr/MagnifyingGlass";
import { MapPin as PhMapPin } from "@phosphor-icons/react/dist/csr/MapPin";
import { Minus as PhMinus } from "@phosphor-icons/react/dist/csr/Minus";
import { Package as PhPackage } from "@phosphor-icons/react/dist/csr/Package";
import { PaperPlaneTilt as PhPaperPlaneTilt } from "@phosphor-icons/react/dist/csr/PaperPlaneTilt";
import { PencilSimple as PhPencilSimple } from "@phosphor-icons/react/dist/csr/PencilSimple";
import { Phone as PhPhone } from "@phosphor-icons/react/dist/csr/Phone";
import { Play as PhPlay } from "@phosphor-icons/react/dist/csr/Play";
import { Plus as PhPlus } from "@phosphor-icons/react/dist/csr/Plus";
import { Printer as PhPrinter } from "@phosphor-icons/react/dist/csr/Printer";
import { ShieldCheck as PhShieldCheck } from "@phosphor-icons/react/dist/csr/ShieldCheck";
import { SignOut as PhSignOut } from "@phosphor-icons/react/dist/csr/SignOut";
import { SquaresFour as PhSquaresFour } from "@phosphor-icons/react/dist/csr/SquaresFour";
import { ThumbsDown as PhThumbsDown } from "@phosphor-icons/react/dist/csr/ThumbsDown";
import { ThumbsUp as PhThumbsUp } from "@phosphor-icons/react/dist/csr/ThumbsUp";
import { Trash as PhTrash } from "@phosphor-icons/react/dist/csr/Trash";
import { TrendDown as PhTrendDown } from "@phosphor-icons/react/dist/csr/TrendDown";
import { Truck as PhTruck } from "@phosphor-icons/react/dist/csr/Truck";
import { UploadSimple as PhUploadSimple } from "@phosphor-icons/react/dist/csr/UploadSimple";
import { VideoCamera as PhVideoCamera } from "@phosphor-icons/react/dist/csr/VideoCamera";
import { Warning as PhWarning } from "@phosphor-icons/react/dist/csr/Warning";
import { Wrench as PhWrench } from "@phosphor-icons/react/dist/csr/Wrench";
import { X as PhX } from "@phosphor-icons/react/dist/csr/X";
import { XCircle as PhXCircle } from "@phosphor-icons/react/dist/csr/XCircle";

// One icon set, one standard. Phosphor under the hood, imported per icon (deep
// imports) so only these 64 glyphs reach the phone instead of the whole library.
// Screens never import an icon library directly, so the set cannot drift again.
//
// Sizes: 20 = navigation / brand / page title · 18 = inline (buttons, rows)
//        14 = tight (chips, meta lines) · 32 = empty state
// Weight: "regular" everywhere. `weight="fill"` is reserved for alarm states
// (P1 / defect / expired) so a filled icon means the same as a filled badge.
export const ICON_NAV = 20;
export const ICON_INLINE = 18;
export const ICON_TIGHT = 14;
export const ICON_EMPTY = 32;

const wrap = (Component, name) => {
  const Wrapped = ({ size = ICON_INLINE, weight = "regular", ...props }) => (
    <Component size={size} weight={weight} {...props} />
  );
  Wrapped.displayName = name;
  return Wrapped;
};

export const AlertTriangle = wrap(PhWarning, "AlertTriangle");
export const ArrowLeft = wrap(PhArrowLeft, "ArrowLeft");
export const ArrowRight = wrap(PhArrowRight, "ArrowRight");
export const ArrowUpDown = wrap(PhArrowsDownUp, "ArrowUpDown");
export const Bell = wrap(PhBell, "Bell");
export const BookOpen = wrap(PhBookOpen, "BookOpen");
export const Boxes = wrap(PhCube, "Boxes");
export const CalendarClock = wrap(PhCalendarDots, "CalendarClock");
export const CalendarDays = wrap(PhCalendarBlank, "CalendarDays");
export const CalendarPlus = wrap(PhCalendarPlus, "CalendarPlus");
export const Check = wrap(PhCheck, "Check");
export const CheckCircle2 = wrap(PhCheckCircle, "CheckCircle2");
export const ChevronDown = wrap(PhCaretDown, "ChevronDown");
export const ChevronLeft = wrap(PhCaretLeft, "ChevronLeft");
export const ChevronRight = wrap(PhCaretRight, "ChevronRight");
export const ChevronUp = wrap(PhCaretUp, "ChevronUp");
export const Circle = wrap(PhCircle, "Circle");
export const ClipboardList = wrap(PhClipboardText, "ClipboardList");
export const Clock = wrap(PhClock, "Clock");
export const Construction = wrap(PhBarricade, "Construction");
export const Copy = wrap(PhCopy, "Copy");
export const Download = wrap(PhDownloadSimple, "Download");
export const Droplets = wrap(PhDrop, "Droplets");
export const Eye = wrap(PhEye, "Eye");
export const FileSpreadsheet = wrap(PhFileXls, "FileSpreadsheet");
export const FileText = wrap(PhFileText, "FileText");
export const Receipt = wrap(PhReceipt, "Receipt");
export const Filter = wrap(PhFunnel, "Filter");
export const GripVertical = wrap(PhDotsSixVertical, "GripVertical");
export const HandCoins = wrap(PhHandCoins, "HandCoins");
export const History = wrap(PhClockCounterClockwise, "History");
export const ImageIcon = wrap(PhImage, "ImageIcon");
export const Info = wrap(PhInfo, "Info");
export const KeyRound = wrap(PhKey, "KeyRound");
export const LayoutDashboard = wrap(PhSquaresFour, "LayoutDashboard");
export const ListChecks = wrap(PhListChecks, "ListChecks");
export const ListPlus = wrap(PhListPlus, "ListPlus");
export const LogOut = wrap(PhSignOut, "LogOut");
export const Mail = wrap(PhEnvelope, "Mail");
export const MailCheck = wrap(PhEnvelopeOpen, "MailCheck");
export const MapPin = wrap(PhMapPin, "MapPin");
export const Menu = wrap(PhList, "Menu");
export const Minus = wrap(PhMinus, "Minus");
export const MoreHorizontal = wrap(PhDotsThree, "MoreHorizontal");
export const Package = wrap(PhPackage, "Package");
export const PackageMinus = wrap(PhTrendDown, "PackageMinus");
export const Pencil = wrap(PhPencilSimple, "Pencil");
export const Phone = wrap(PhPhone, "Phone");
export const Play = wrap(PhPlay, "Play");
export const Plus = wrap(PhPlus, "Plus");
export const Printer = wrap(PhPrinter, "Printer");
export const RefreshCw = wrap(PhArrowsClockwise, "RefreshCw");
export const RotateCcw = wrap(PhArrowCounterClockwise, "RotateCcw");
export const Search = wrap(PhMagnifyingGlass, "Search");
export const Send = wrap(PhPaperPlaneTilt, "Send");
export const Settings = wrap(PhGearSix, "Settings");
export const ShieldCheck = wrap(PhShieldCheck, "ShieldCheck");
export const ThumbsDown = wrap(PhThumbsDown, "ThumbsDown");
export const ThumbsUp = wrap(PhThumbsUp, "ThumbsUp");
export const Trash2 = wrap(PhTrash, "Trash2");
export const Truck = wrap(PhTruck, "Truck");
export const Upload = wrap(PhUploadSimple, "Upload");
export const Video = wrap(PhVideoCamera, "Video");
export const Wrench = wrap(PhWrench, "Wrench");
export const X = wrap(PhX, "X");
export const XCircle = wrap(PhXCircle, "XCircle");
